// src/pages/outsourcing_management/AppLink.tsx
//
// An in-app link: a real href (so it opens in a new tab on middle-click) that
// navigates through the router on a plain click. Built on react-router's
// useHistory and the MUI Link, as react-router-dom ships no type declarations
// in this project.
import { FunctionComponent, MouseEvent, ReactNode } from "react";
import { useHistory } from "react-router";
import { Link } from "@mui/material";

type PropsType = {
  to: string;
  onClick?: () => void;
  children: ReactNode;
};

const AppLink: FunctionComponent<PropsType> = ({ to, onClick, children }) => {
  const history = useHistory();
  const go = (e: MouseEvent) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    onClick?.();
    history.push(to);
  };
  return (
    <Link href={to} onClick={go}>
      {children}
    </Link>
  );
};

export default AppLink;
